import React from "react";
import { Linkedin, ArrowUpRight, Mail, Instagram } from "lucide-react";

const SOCIALS = [
  { icon: Linkedin, href: "https://www.linkedin.com/in/ankita-gogia-4ab9011b", label: "LinkedIn" },
  { icon: Instagram, href: "https://www.instagram.com/ankitagogiadesigns/", label: "Instagram" },
  { icon: ArrowUpRight, href: "https://www.behance.net/ankitagogia", label: "Behance" },
  { icon: Mail, href: "mailto:ankitagogiaillustrator@gmail.com", label: "Email" },
];

export const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <footer className="bg-cream border-t border-charcoal/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <button onClick={scrollTop} className="font-heading text-3xl tracking-tight text-charcoal">
            Ankita Gogia<span className="text-burgundy">.</span>
          </button>
          <div className="flex items-center gap-4">
            {SOCIALS.map((s) => {
              const Icon = s.icon;
              return (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-charcoal/15 text-charcoal hover:bg-burgundy hover:text-cream hover:border-burgundy hover:-translate-y-1 transition-all duration-300"
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                >
                  <Icon size={18} />
                </a>
              );
            })}
          </div>
        </div>
        <div className="mt-10 pt-8 border-t border-charcoal/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-sm text-charcoal/50">
          <p>© {new Date().getFullYear()} Ankita Gogia. Brand Strategy & Creative Direction.</p>
          <p className="italic font-heading text-charcoal/60">Designing brands people remember.</p>
        </div>
      </div>
    </footer>
  );
};
